const translations = {
    noApplicationsFound: 'No applications found.',
    search: 'Search'
};

export default translations;
